export const resultConstants = {
    RESULT_CREATE:      'RESULT_PAGE_CREATE',
    RESULT_REQUEST:     'RESULT_PAGE_REQUEST',
    RESULT_SUCCESS:     'RESULT_PAGE_SUCCESS',
    RESULT_FAILURE:     'RESULT_PAGE_FAILURE'
}